import Grid from '@mui/material/Grid';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { divisionApiKeyStore } from '../../../api/masters/division-api-key-store';
import { ServiceCategory } from '../../../models/masters/service-category';
interface IServiceCategoryForm {
  editItem?: Partial<ServiceCategory> | undefined;
}
export const ServiceCategoryForm = ({ editItem }: IServiceCategoryForm) => {
  const options = [
    {
      value: true,
      label: 'Yes',
      isDefault: false,
    },
    {
      value: false,
      label: 'No',
      isDefault: true,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Service Category Name" name="serviceCategoryName" maxLength={150} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput
          label="Service Category Code"
          name="serviceCategoryCode"
          maxLength={150}
          disabled={!!editItem?.serviceCategoryID}
        />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelectDynamic
          name="divisionID"
          label="Division"
          getQueryKeyConfig={() => divisionApiKeyStore.getDivisions()}
          optionsValueKey="divisionID"
          optionsLabelKeys={['divisionName']}
        />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelect label="Plan Review" name="isPlanRequired" options={options} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
          <FormCheckbox label="Active" name="isActive" />
        </Grid>
      </Grid>
    </Grid>
  );
};
